import axiosConfig from "./axiosConfig";

export interface MatchCandidate {
  site_id: string;
  site_name: string;
  confidence: number;
  rationale: string;
  esys_keys: string[];
  // The specific esys key(s) whose grid connection matches an MPAN found in the file, so a
  // per-meter curve targets (site, esys). Empty when the site's esys carry no MPAN (the common
  // initial state) - the FE then falls back to first-free esys by idx.
  matched_esys_keys: string[];
}

export interface MatchResult {
  filename: string;
  file_guid: string;
  candidates: MatchCandidate[];
  source: "explicit" | "fuzzy" | "none";
  multi_site_suspected: boolean;
}

export interface OrgSiteForMatch {
  id: string;
  name: string;
  esys_keys: string[];
}

export interface MatchToSitesRequest {
  fileGuids: string[];
  orgId: string;
  explicitMapping?: Record<string, string[]>;
}

// The eventual matcher result, read from the LRO operation result via /async_status.
export interface MatchToSitesResponse {
  matches: MatchResult[];
  // The full list of sites in the target org, so the FE's typeahead can offer ANY
  // site as an override - not just sites that appeared as candidates.
  orgSites: OrgSiteForMatch[];
}

// Matching peeks every uploaded file from S3, which exceeds the API Gateway budget at
// portfolio scale, so the POST kicks off a tier-2 LRO and returns a handle to poll.
export interface MatchToSitesKickoff {
  operationKey: string;
  siteId: string;
  status: string;
}

const postHhDataMatchToSites = async (
  authToken: string,
  request: MatchToSitesRequest
): Promise<MatchToSitesKickoff> => {
  const { data } = await axiosConfig.post("/hh_data/match_to_sites", request, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default postHhDataMatchToSites;
